const DEMO_MODE = false;

function setupConsentLink() {
    if (typeof window["__tcfapi"] == "undefined") {
        // Consent API was not loaded by NitroAds, which means that it's not needed
        return true;
    }

    const consentElement = document.querySelector(".consent-link-wrapper");
    if (!consentElement) {
        return false;
    }

    const a = document.createElement("a");
    a.setAttribute("href", "javascript:void 0");
    a.innerHTML = "Zaktualizuj preferencje cookies";
    a.addEventListener("click", () => {
        // @ts-ignore
        window.__cmp("showModal");
    });
    consentElement.appendChild(a);
    return true;
}

function createRailAd(side: "left" | "right") {
    window["nitroAds"].createAd(`ad-${side}-rail`, {
        demo: DEMO_MODE,
        refreshTime: 30,
        format: "rail",
        rail: side,
        railOffsetTop: 0,
        railOffsetBottom: 0,
        railCollisionWhitelist: [".no-rail-collision"],
        sizes: [
            ["160", "600"],
            ["300", "600"],
        ],
        report: {
            enabled: true,
            icon: true,
            wording: "Report Ad",
            position: `bottom-${side}`,
        },
        mediaQuery: "(min-width: 1025px), (min-width: 768px) and (max-width: 1024px)",
    });
}

function fixRailCollisions() {
    // Margoworld does not use iframes, any iframes present are some weird loaders which should not collide
    const frames = document.querySelectorAll("iframe");
    for (const frame of Array.from(frames)) {
        frame.classList.add("no-rail-collision");
    }
}

function createBannerAd(container: HTMLDivElement) {
    const id = container.getAttribute("id");
    if (typeof id != "string") {
        console.error(`createBannerAd: invalid id: ${id}`, container);
        return;
    }
    try {
        const sizes = JSON.parse(container.dataset.sizes);
        window["nitroAds"].createAd(id, {
            demo: DEMO_MODE,
            refreshTime: 30,
            renderVisibleOnly: false,
            sizes: sizes,
            report: {
                enabled: true,
                icon: true,
                wording: "Report Ad",
                position: "bottom-right",
            },
            mediaQuery: container.dataset.query,
        });
    } catch (e) {
        console.error(`createBannerAd failed: `, e);
    }
}

function createAnchorAd() {
    window["nitroAds"].createAd("ad-mobile-anchor", {
        demo: DEMO_MODE,
        refreshTime: 30,
        format: "anchor",
        anchor: "bottom",
        anchorPersistClose: false,
        report: {
            enabled: true,
            icon: true,
            wording: "Report Ad",
            position: "top-right",
        },
        mediaQuery: "(min-width: 320px) and (max-width: 767px)",
    });
    // Add bottom margin to footer, in order to make it visible
    const footer = document.querySelector("footer");
    if (footer) {
        footer.style.marginBottom = "50px";
    }
}

function setupAds() {
    fixRailCollisions();

    // Rail ads
    createRailAd("left");
    createRailAd("right");
    createAnchorAd();

    for (const section of Array.from(document.querySelectorAll(".ad-section"))) {
        if (section instanceof HTMLDivElement) {
            section.style.display = "block";
        }
    }

    for (const container of Array.from(document.querySelectorAll(".ad-banner-container"))) {
        if (container instanceof HTMLDivElement) {
            createBannerAd(container);
        }
    }
}

function onAdsLoaded() {
    if (!setupConsentLink()) {
        console.error(`Consent setup failed; not proceeding with ad code`);
        return;
    }
    setupAds();
}

export function initAds() {
    if (window["nitroAds"] && window["nitroAds"].loaded) {
        onAdsLoaded();
    } else {
        document.addEventListener("nitroAds.loaded", onAdsLoaded);
    }
}
